export default {
  validate: (bicycleLaptopItemValue) => {
    return {
      required: true,
      valid: bicycleLaptopItemValue && Number.isInteger(bicycleLaptopItemValue),
    };
  },
  message: (fieldName, { _value_: bicycleLaptopItemValue }) => {
    if (!bicycleLaptopItemValue || !Number.isInteger(bicycleLaptopItemValue)) return 'Please enter a number e.g. 1000.';
  },
  computesRequired: true,
};
